import { replaceBadEncodedChars } from '@osf/shared/helpers/format-bad-encoding.helper';
import { BrandDataJsonApi } from '@osf/shared/models/brand/brand.json-api.model';
import { BrandModel } from '@osf/shared/models/brand/brand.model';
import { SubjectModel } from '@osf/shared/models/subject/subject.model';
import { SubjectDataJsonApi } from '@osf/shared/models/subject/subjects-json-api.model';

import { PreprintProviderDetails, PreprintProviderDetailsJsonApi, PreprintProviderShortInfo } from '../models';

export class PreprintProvidersMapper {
  static fromPreprintProviderDetailsGetResponse(response: PreprintProviderDetailsJsonApi): PreprintProviderDetails {
    const brandRaw = response.embeds!.brand?.data;
    return {
      id: response.id,
      name: replaceBadEncodedChars(response.attributes.name),
      descriptionHtml: replaceBadEncodedChars(response.attributes.description),
      advisoryBoardHtml: response.attributes.advisory_board,
      examplePreprintId: response.attributes.example,
      domain: response.attributes.domain,
      footerLinksHtml: response.attributes.footer_links,
      preprintWord: response.attributes.preprint_word,
      allowSubmissions: response.attributes.allow_submissions,
      assertionsEnabled: response.attributes.assertions_enabled,
      permissions: response.attributes.permissions,
      brand: PreprintProvidersMapper.parseBrand(brandRaw),
      iri: response.links.iri,
      faviconUrl: response.attributes.assets?.favicon,
      squareColorNoTransparentImageUrl: response.attributes.assets?.square_color_no_transparent,
      reviewsWorkflow: response.attributes.reviews_workflow,
      facebookAppId: response.attributes.facebook_app_id,
      reviewsCommentsPrivate: response.attributes.reviews_comments_private,
      reviewsCommentsAnonymous: response.attributes.reviews_comments_anonymous,
    };
  }

  static parseBrand(brandRaw: BrandDataJsonApi): BrandModel {
    if (!brandRaw) {
      return {
        primaryColor: 'var(--osf-provider-primary-color)',
        secondaryColor: 'var(--osf-provider-secondary-color)',
      } as BrandModel;
    }

    return {
      id: brandRaw.id,
      name: brandRaw.attributes.name,
      heroLogoImageUrl: brandRaw.attributes.hero_logo_image,
      heroBackgroundImageUrl: brandRaw.attributes.hero_background_image,
      topNavLogoImageUrl: brandRaw.attributes.topnav_logo_image,
      primaryColor: brandRaw.attributes.primary_color,
      secondaryColor: brandRaw.attributes.secondary_color,
      backgroundColor: brandRaw.attributes.background_color,
    };
  }

  static toPreprintProviderShortInfoFromGetResponse(
    response: PreprintProviderDetailsJsonApi[]
  ): PreprintProviderShortInfo[] {
    return response.map((item) => ({
      id: item.id,
      name: replaceBadEncodedChars(item.attributes.name),
      descriptionHtml: replaceBadEncodedChars(item.attributes.description),
      whiteWideImageUrl: item.attributes.assets?.wide_white,
      squareColorNoTransparentImageUrl: item.attributes.assets?.square_color_no_transparent,
    }));
  }

  static fromSubjectsGetResponse(data: SubjectDataJsonApi[]): SubjectModel[] {
    return data.map((subject) => ({
      id: subject.id,
      name: subject.attributes.text,
      iri: subject.links.iri,
    }));
  }
}
